module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.activeClass,
    attrs: {
      "id": "right-sidebar"
    }
  }, [_c('div', {
    directives: [{
      name: "slimScroll",
      rawName: "v-slimScroll",
      value: ({
        height: '100%',
        railOpacity: 0.4,
        wheelStep: 10
      }),
      expression: "{height:'100%',railOpacity:0.4,wheelStep:10}"
    }],
    staticClass: "sidebar-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab-1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "skin-setttings"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("主题设置")]), _vm._v(" "), _c('div', {
    staticClass: "setings-item"
  }, [_c('span', [_vm._v("固定顶部")]), _vm._v(" "), _c('SwitchBox', {
    attrs: {
      "switchName": "fixNav"
    },
    on: {
      "checkChange": _vm.fixedNav
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("皮肤选择")]), _vm._v(" "), _c('div', {
    staticClass: "setings-item default-skin nb"
  }, [_c('span', {
    staticClass: "skin-name "
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changetheme('')
      }
    }
  }, [_vm._v("\n                             默认皮肤\n                         ")])])]), _vm._v(" "), _c('div', {
    staticClass: "setings-item blue-skin nb"
  }, [_c('span', {
    staticClass: "skin-name "
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changetheme('skin-1')
      }
    }
  }, [_vm._v("\n                            蓝色主题\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "setings-item yellow-skin nb"
  }, [_c('span', {
    staticClass: "skin-name "
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changetheme('skin-3')
      }
    }
  }, [_vm._v("\n                            黄色/紫色主题\n                        ")])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs navs-3"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" 主题\n\t\t\t\t\t")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t通知\n\t\t\t\t\t")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab-3"
    }
  }, [_vm._v("\n\t\t\t\t\t\t项目进度\n\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-title"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" 主题设置")]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-tim"
  }), _vm._v(" 你可以从这里选择和预览主题的布局和样式，这些设置会被保存在本地，下次打开的时候会直接应用这些设置。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-2"
    }
  }, [_c('div', {
    staticClass: "sidebar-title"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" 最新通知")]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-tim"
  }), _vm._v(" 您当前有10条未读信息")])]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-3"
    }
  }, [_c('div', {
    staticClass: "sidebar-title"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" 最新任务")]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-tim"
  }), _vm._v(" 您当前有14个任务，10个已完成")])]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-list"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d6cbd31","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/RightSidebar.vue
// module id = 1507
// module chunks = 0